import React from 'react';
import Navigation from '../components/common/Navigation';
import Footer from '../components/common/Footer';
import CookiesConsent from '../components/common/CookiesConsent';
import Hero from '../components/home/Hero';
import Strategy from '../components/home/Strategy';
import SolanaBet from '../components/home/SolanaBet';
import Advantages from '../components/home/Advantages';
import PurchaseHistory from '../components/home/PurchaseHistory';
import Metrics from '../components/home/Metrics';
import Globe from '../components/home/Globe';

const Home = () => {
  return (
    <>
      <Navigation />
      <main className="main-wrapper">
        <Hero />
        <Strategy />
        <SolanaBet />
        <Advantages />
        <PurchaseHistory />
        <Metrics />
      </main>
      <Footer />
      <CookiesConsent />
      <Globe />
    </>
  );
};

export default Home;